<template>
  <div class="container">
    <TableList
      style="height: 400px"
      :columns="tabPaneConfig[0].columns"
      :tableData="tabPaneConfig[0].tableData"
      :loading="tabPaneConfig[0].loading"
      :scroll="{ x: 2200 }"
      :pagination="tabPaneConfig[0].pagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" class="query-area">
        <div>
          <j-dict-select-tag
            placeholder="请选择年级"
            v-model="queryParam.gradeId"
            class="search-space"
            dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
            allowClear
            @change="() => $set(queryParam, 'classId', undefined)"
            @input="() => $set(queryParam, 'classId', undefined)"
            @clear="() => $set(queryParam, 'classId', undefined)"
          />
          <j-dict-select-tag
            placeholder="请选择班级"
            v-model="queryParam.classId"
            class="search-space"
            :dictCode="
              'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
            "
            :async="true"
          />
          <a-range-picker
            v-model="dateRange"
            @change="(dates, dateString) => onRangeChange(dates, dateString)"
            class="search-space"
            style="width: 230px"
          />
          <a-input-search
            v-model="queryParam.studentName"
            placeholder="请输入学生名字"
            class="search-space"
            style="width: 170px"
            @change="searchName"
          />
          <a-button type="primary" @click="queryTable">查询</a-button>
        </div>

        <div>
          <a-button
            type="primary"
            icon="download"
            style="margin-right: 10px"
            :loading="exportXlsLoading"
            @click="handleExportXlsv2('学生辅导')"
          >
            导出
          </a-button>
          <a-button type="primary" @click="addLedger">添加台账</a-button>
        </div>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <span @click="editLedger(record)">编辑</span>
          <!-- <a-divider type="vertical" /> -->
          <!-- <a-popconfirm title="确定删除该条记录？" @confirm="deleteLedger(record)">
            <span style="color: #ff4d4f">删除</span>
          </a-popconfirm> -->
          <a-divider type="vertical" />
          <span @click="vieLedger(record)">查看</span>
        </div>
      </template>
    </TableList>
    <AddLedgerModal ref="addLedgerModalRef" @refreshData="loadData" />
  </div>
</template>
<script>
import Vue from 'vue'
import { IDENTITY_ID, USER_INFO } from '@/store/mutation-types'
import TableList from '@/components/chart/TableList'
import { deleteAction, getAction } from '@api/manage'
import { getDictCodeData, simpleDebounce } from '@/utils/util'
import AddLedgerModal from './components/AddLedgerModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import moment from 'moment'

const tablePagination = {
  current: 0,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

export default {
  name: 'StudentTutor',
  components: {
    TableList,
    AddLedgerModal,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      tabKey: 1,
      queryParam: {},
      dateRange: [],
      tabPaneConfig: [
        {
          // columns: [
          //   {
          //     title: '序号',
          //     dataIndex: 'index',
          //     align: 'center',
          //   },
          //   {
          //     title: '班级',
          //     dataIndex: 'className',
          //     align: 'center',
          //     width: 100,
          //   },
          //   {
          //     title: '学生',
          //     dataIndex: 'studentName',
          //     align: 'center',
          //     width: 100,
          //   },
          //   {
          //     title: '到访时间',
          //     dataIndex: 'tutoringTime',
          //     align: 'center',
          //     width: 150,
          //     customRender: (_, record) => {
          //       return moment(record.tutoringTime).format('YYYY-MM-DD')
          //     },
          //   },
          //   {
          //     title: '辅导类型',
          //     dataIndex: 'tutoringType',
          //     align: 'center',
          //     width: 100,
          //     customRender: (_, record) => {
          //       const res = getDictCodeData('tutoring_type', record.tutoringType)
          //       return res.text
          //     },
          //   },
          //   {
          //     title: '具体情况',
          //     dataIndex: 'specificInstructions',
          //     align: 'center',
          //     customRender: (text) => {
          //       const cleanText = this.stripHtmlTags(text)
          //       if (!cleanText) return '--'
          //       return cleanText.length >= 60 ? (
          //         <a-tooltip >
          //           <template slot="title">{cleanText}</template>
          //           {cleanText.substring(0, 60) + '...'}
          //         </a-tooltip>
          //       ) : (
          //         cleanText
          //       )
          //     },
          //   },
          //   {
          //     title: '操作',
          //     dataIndex: 'action',
          //     align: 'center',
          //     scopedSlots: { customRender: 'action' },
          //   },
          // ],
          columns:[
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
              width: 70,
              customRender: (text, record, index) => index + 1,
            },
            {
              title: '班级',
              dataIndex: 'className',
              align: 'center',
              width: 120,
            },
            {
              title: '学生',
              dataIndex: 'studentName',
              align: 'center',
              width:  120 ,
              // 移除宽度，使其在待关爱页签下成为弹性列
            },
            {
              title: '关爱等级',
              dataIndex: 'careList',
              align: 'center',
              width:  120 ,
            },
            // {
            //   title: '辅导次数',
            //   dataIndex: 'tutorSumCount',
            //   align: 'center',
            //   width:  120 ,
            //   customRender: (text) => text || 0,
            // },
            {
              title: '本学期提醒次数',
              dataIndex: 'termRemindCount',
              align: 'center',
              width:  150 ,
              minWidth: 140,
              customRender: (text) => text || 0,
            },
            {
              title: '辅导时间',
              dataIndex: 'tutoringTime',
              align: 'center',
              width: 150,
              customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
            },
            {
              title: '辅导类型',
              dataIndex: 'tutoringType_dictText',
              align: 'center',
              width: 150,
              customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
            },
            {
              title: '辅导方法',
              dataIndex: 'tutoringMethod_dictText',
              align: 'center',
              width: 150,
              customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
            },
            {
              title: '问题原因',
              dataIndex: 'reason_dictText',
              align: 'center',
              width: 180,
              customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
            },
            {
              title: '下一步措施',
              dataIndex: 'nextIntervention_dictText',
              align: 'center',
              width: 200,
              customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
            },
            {
              title: '效果反馈',
              dataIndex: 'effectFeedback_dictText',
              align: 'center',
              width: 180,
              customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
            },
            {
              title: '是否反馈校领导',
              dataIndex: 'feedbackFlag',
              align: 'center',
              width: 180,
              customRender: (text) => <div class="wrap-text">{text == 1 ? '是' : '否'}</div>,
            },
            {
              title: '校领导名称',
              dataIndex: 'leaderName',
              align: 'center',
              width: 180,
              customRender: (text) => <div class="wrap-text">{text || '--'}</div>,
            },
            {
              title: '具体情况说明',
              dataIndex: 'specificInstructions',
              align: 'center',
              width: 300,
              customRender: (text, record) => {
                const rawVal = text || record.comment || record.remark || ''
                if (!rawVal) return '--'
                // 移除 HTML 标签以便在 Tooltip 中显示纯文本
                const cleanVal = rawVal.replace(/<[^>]+>/g, '')
                return cleanVal.length >= 30 ? (
                  <a-tooltip>
                    <template slot="title">{cleanVal}</template>
                    <div class="wrap-text">{cleanVal.substring(0, 30) + '...'}</div>
                  </a-tooltip>
                ) : (
                  <div class="wrap-text">{cleanVal}</div>
                )
              },
            },
            {
              title: '心理老师',
              dataIndex: 'creatorName',
              align: 'center',
              width: 100,
              customRender: (text) => text || '--',
            },
            {
              title: '处理时间',
              dataIndex: 'createTime',
              align: 'center',
              width: 150,
              customRender: (text) => text || '--',
            },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              width: 180,
              fixed: 'right',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '/schoolCounselingRecord/list',
        importExcelUrl: '',
        exportXlsUrl: '/schoolCounselingRecord/counselingRecordExport',
      },
      detailModalData: [],
      identityId: '',
      userIdentityList: [],
      currIderntity: '',
    }
  },
  // created() {
  //   this.loadData()
  // },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    handleTabChange() {
      this.queryParam = {}
      this.detailModalData = []
      this.loadData()
    },
    onRangeChange() {
      this.$set(
        this.queryParam,
        'beginDate',
        this.dateRange?.[0] && moment(this.dateRange[0]).format('YYYY-MM-DD')
      )
      this.$set(
        this.queryParam,
        'endDate',
        this.dateRange?.[1] && moment(this.dateRange[1]).format('YYYY-MM-DD')
      )
    },
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    // 查询
    queryTable() {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      const name = event.target.value
      this.getTableData()
    }, 500),
    loadData() {
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', 'schoolCounselingRecord/list')
          break
      }
      this.getTableData()
      // this.queryParam = {}
    },
    getTableData() {
      this.currIderntity = Vue.ls.get(USER_INFO).userIdentity.split(',')
      this.identityId = Vue.ls.get(IDENTITY_ID) || this.currIderntity[0]
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      const params = {
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        dataType: 8,
        userIdentity: this.identityId,
        role: this.identityId,
        ...this.isorter,
        ...this.queryParam,
      }
      getAction(this.url.list, params)
        .then((res) => {
          console.log('获取列表数据--', res)
          if (res.success) {
            if (this.tabKey - 1 == 0) {
              if (res.result.records.length > 0) {
                res.result.records.forEach((item) => {
                  item.commentText = this.stripHtmlTags(item.comment)
                })
              }
            }
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => ({
                  ...item,
                  index: index + 1,
                }))
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    // 去除HTML标签，获取纯文本
    stripHtmlTags(html) {
      if (!html) return ''
      const temp = document.createElement('div')
      temp.innerHTML = html
      return temp.textContent || temp.innerText || ''
    },
    addLedger() {
      this.$refs.addLedgerModalRef.showModal()
    },
    editLedger(record) {
      this.$refs.addLedgerModalRef.showModal(record, 'edit')
    },
    async deleteLedger(record) {
      const res = await deleteAction('/schoolCounselingRecord/delete', { id: record.id })
      if (res.success) {
        this.$message.success(res.message)
        this.loadData()
        return
      }
      this.$message.error(res.message)
    },
    vieLedger(record) {
      this.$refs.addLedgerModalRef.showModal(record, 'view')
    },
    handleExportXlsv2(title) {
      const params = {
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        dataType: 8,
        userIdentity: this.identityId,
        role: this.identityId,
        ...this.isorter,
        ...this.queryParam,
      }
      this.handleExportXls(title, params)
    },
  },
}
</script>
<style scoped lang="less">
.container {
  padding: 0 20px;
  background-color: #fff;
  border-radius: 10px;
}

.query-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}

.search-space {
  width: 170px;
  margin-right: 15px;
}
</style>
